/* Auto-generated by scripts/fetch-judgeme-reviews.js — do not edit by hand. */
/* Generated at: 2026-10-31T15:43:39.120Z */
window.jrReviewsData = {
  "heal-seal-trio": {
    "productId": 8644190371919,
    "productTitle": "Heal & Seal Trio",
    "reviews": [
      {
        "id": 1400625309,
        "rating": 5,
        "title": "",
        "body": "I am really satisfied with the Heal & Seal Trio. It feels amazing on my skin and has significantly improved its overall health. It absorbs quickly and keeps my skin moisturized all day long. Highly recommended",
        "name": "Aah David ",
        "created_at": "2026-10-30T07:32:40+00:00",
        "verified": false,
        "pictures": [
          {
            "url": "https://review-images.judgeme.com/jiyu/1793345560__heal-seal-trio-1-jar__original.jpg?quality=80&width=160"
          }
        ]
      },
      {
        "id": 1400567021,
        "rating": 5,
        "title": "",
        "body": "Product Provided At No Cost. at the end.",
        "name": "Hawala DER",
        "created_at": "2026-10-30T07:08:05+00:00",
        "verified": false,
        "pictures": [
          {
            "url": "https://review-images.judgeme.com/jiyu/1793344086__screenshot_20261030-130332__original.jpg?quality=80&width=160"
          }
        ]
      },
      {
        "id": 1400566019,
        "rating": 5,
        "title": "",
        "body": "Product Provided At No Cost",
        "name": "SHUVO Rh",
        "created_at": "2026-10-30T07:07:34+00:00",
        "verified": false,
        "pictures": [
          {
            "url": "https://review-images.judgeme.com/jiyu/1793344054__1000074338__original.jpg?quality=80&width=160"
          }
        ]
      },
      {
        "id": 1400562191,
        "rating": 5,
        "title": "",
        "body": "পণ্যটি বিনামূল্যে প্রদান করা হয়েছে",
        "name": "Sarah",
        "created_at": "2026-10-30T07:05:23+00:00",
        "verified": false,
        "pictures": []
      },
      {
        "id": 1400558745,
        "rating": 5,
        "title": "",
        "body": "প্রোডাক্টটা অনেক ভালো সবাই নিয়ে দেখতে পারেন বেস্ট প্রডাক্ট",
        "name": "John",
        "created_at": "2026-10-30T07:01:20+00:00",
        "verified": false,
        "pictures": []
      },
      {
        "id": 1400556325,
        "rating": 5,
        "title": "",
        "body": "Absolutely love this skincare set! The packaging is beautiful, and I love how simple and convenient the 3-step routine is. My skin feels smoother, softer, and more refreshed after using it. The pads are easy to use, and the moisturizer keeps my skin feeling hydrated. Definitely a great addition to my skincare routine. Moreover product provided at no cost",
        "name": "Customer",
        "created_at": "2026-10-30T06:59:53+00:00",
        "verified": false,
        "pictures": [
          {
            "url": "https://review-images.judgeme.com/jiyu/1793343593__10411__original.jpg?quality=80&width=160"
          }
        ]
      },
      {
        "id": 1400552862,
        "rating": 5,
        "title": "",
        "body": "Product Provided At No Cost.",
        "name": "Ra",
        "created_at": "2026-10-30T06:57:50+00:00",
        "verified": false,
        "pictures": []
      },
      {
        "id": 1400551688,
        "rating": 5,
        "title": "",
        "body": "It's really good product",
        "name": "Nirobnoob",
        "created_at": "2026-10-30T06:57:07+00:00",
        "verified": false,
        "pictures": []
      }
    ]
  },
  "nad-anti-aging-moisturizing-cream": {
    "productId": 7935970246735,
    "productTitle": "Anti-Aging Moisturizing Cream",
    "reviews": [
      {
        "id": 1393098470,
        "rating": 5,
        "title": "",
        "body": "Love this brand",
        "name": "Jasmina Bajgoric",
        "created_at": "2026-10-23T15:31:53+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1390184484,
        "rating": 5,
        "title": "",
        "body": "I like that my pores are nice and clean and shrinking after using the toner pads followed by this moisturizer",
        "name": "Genia Johnson",
        "created_at": "2026-10-21T17:26:44+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1387352786,
        "rating": 5,
        "title": "",
        "body": "My skin texture has improved.",
        "name": "Lona ",
        "created_at": "2026-10-19T21:40:11+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1356571898,
        "rating": 5,
        "title": "",
        "body": "Leaves my skin feeling soft and moisturized without making it feel greasy.",
        "name": "Patricia R Johnson",
        "created_at": "2026-09-28T23:45:15+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1352179185,
        "rating": 5,
        "title": "",
        "body": "I get a facial every five weeks and she asked me what I have done as she noticed the structure of my skin seems different. I love this stuff",
        "name": "James K.",
        "created_at": "2026-09-25T22:14:29+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1331298436,
        "rating": 5,
        "title": "",
        "body": "I lovr absolutely love this product.",
        "name": "Allison Morrissey",
        "created_at": "2026-09-13T16:48:54+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1316865617,
        "rating": 5,
        "title": "",
        "body": "I saw a utube and thought interesting. Saw the before and after. I’m about two weeks in and I notice a difference in the first few days. I’m 65 and love the product.",
        "name": "Customer",
        "created_at": "2026-08-31T20:08:33+00:00",
        "verified": false,
        "pictures": []
      },
      {
        "id": 1307349271,
        "rating": 5,
        "title": "",
        "body": "Love love lovvveee! I’ve been using the indigo cream by Tatcha for years, and this is seriously up and up! Plus almost half the price 😁",
        "name": "Anonymous",
        "created_at": "2026-08-23T22:00:00+00:00",
        "verified": false,
        "pictures": []
      }
    ]
  },
  "polish-pads": {
    "productId": 8644190339151,
    "productTitle": "Cleansing Polish Pads",
    "reviews": [
      {
        "id": 1398804476,
        "rating": 5,
        "title": "",
        "body": "I just received it do not sure yet how it will work but the toner pad works perfect so I’m anticipating that these will be just as good.",
        "name": "Zandrina Powell",
        "created_at": "2026-10-29T02:00:07+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1396023764,
        "rating": 5,
        "title": "",
        "body": "Customer service was outstanding.",
        "name": "Customer",
        "created_at": "2026-10-26T20:00:21+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1303180269,
        "rating": 5,
        "title": "",
        "body": "Just an amazing product!",
        "name": "Anonymous",
        "created_at": "2026-08-18T22:00:00+00:00",
        "verified": false,
        "pictures": []
      },
      {
        "id": 1303180270,
        "rating": 5,
        "title": "",
        "body": "All the all the pimples that I have is dry and cleaning my skin",
        "name": "Anonymous",
        "created_at": "2026-08-16T22:00:00+00:00",
        "verified": false,
        "pictures": []
      },
      {
        "id": 1303180272,
        "rating": 5,
        "title": "",
        "body": "These are great when your having a acne breakout. Just remember to rinse your face after use.",
        "name": "Anonymous",
        "created_at": "2026-08-15T22:00:00+00:00",
        "verified": false,
        "pictures": []
      },
      {
        "id": 1303180382,
        "rating": 5,
        "title": "",
        "body": "I’m was very impressed how smooth and shiny my skin was after using just one time! Excellent exfoliating cleansing pads!👌🥰",
        "name": "Anonymous",
        "created_at": "2026-08-15T22:00:00+00:00",
        "verified": false,
        "pictures": []
      },
      {
        "id": 1303180381,
        "rating": 5,
        "title": "",
        "body": "I cannot wait to use it Korean based skin care with the central ingredients amazing",
        "name": "Anonymous",
        "created_at": "2026-08-14T22:00:00+00:00",
        "verified": false,
        "pictures": []
      },
      {
        "id": 1303180385,
        "rating": 5,
        "title": "",
        "body": "This product is so good. I’m so happy now purchase it. I’m very satisfied with this product.",
        "name": "Anonymous",
        "created_at": "2026-08-12T22:00:00+00:00",
        "verified": false,
        "pictures": []
      }
    ]
  },
  "pore-reset-duo": {
    "productId": 8644190437455,
    "productTitle": "Pore Reset Duo",
    "reviews": [
      {
        "id": 1395891354,
        "rating": 5,
        "title": "",
        "body": "Works so well! My face is softer and a more clear complexion! I use one a day and alternate between the two!",
        "name": "Chloe Gadsden",
        "created_at": "2026-10-26T16:21:45+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1377325189,
        "rating": 5,
        "title": "",
        "body": "The amount of dirt the scrub side takes off my face is mindblowing. I use this twice a day and I normally have significant breakout around my menstrual cycle but since using this its being very minimal.  I give it 5star",
        "name": "Oluwadunni Obasoto",
        "created_at": "2026-10-13T17:00:14+00:00",
        "verified": true,
        "pictures": [
          {
            "url": "https://review-images.judgeme.com/jiyu/1791910815__1000642179__original.jpg?quality=80&width=160"
          }
        ]
      },
      {
        "id": 1372492497,
        "rating": 5,
        "title": "",
        "body": "My skin is looking and feeling so much clearer and smoother. Love the product and will continue to use as my daily routine",
        "name": "Nita K.",
        "created_at": "2026-10-10T16:02:12+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1330019911,
        "rating": 5,
        "title": "",
        "body": "One use this morning I can only tell it. It's a great product.",
        "name": "Joseph Romero",
        "created_at": "2026-09-12T00:57:50+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1298939839,
        "rating": 5,
        "title": "",
        "body": "Just started using so dont know how effective",
        "name": "Jacqueline Hernandez",
        "created_at": "2026-08-18T03:09:04+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1288604647,
        "rating": 5,
        "title": "",
        "body": "Arrived quickly. Now I just need to try it out.",
        "name": "patricia cortez",
        "created_at": "2026-08-07T22:13:07+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1309871566,
        "rating": 5,
        "title": "",
        "body": "Feels so nice in my skin.",
        "name": "Customer",
        "created_at": "2026-07-31T17:36:45+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1264499091,
        "rating": 5,
        "title": "",
        "body": "Seems fantastic so fsr! First morning trying it..",
        "name": "Rachael Genicoff",
        "created_at": "2026-07-20T14:45:53+00:00",
        "verified": true,
        "pictures": []
      }
    ]
  },
  "renewal-rejuvenation-toner-pads": {
    "productId": 7935974375503,
    "productTitle": "Renewal & Rejuvenation Toner Pads",
    "reviews": [
      {
        "id": 1401452920,
        "rating": 5,
        "title": "",
        "body": "The Renewal and Rejuvenation Toner Pads are great! I can definitely see a difference in my skin's brightness and texture.  I love the feeling my skin receives when applying. The pads are not too harsh for my sensitive skin.",
        "name": "Kathy H.",
        "created_at": "2026-10-30T21:55:47+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1400133093,
        "rating": 5,
        "title": "",
        "body": "Received all 3 jars, love, love this product",
        "name": "Customer",
        "created_at": "2026-10-29T23:56:54+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1397597182,
        "rating": 5,
        "title": "",
        "body": "Mild and effective",
        "name": "Customer",
        "created_at": "2026-10-28T08:08:50+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1395972742,
        "rating": 5,
        "title": "",
        "body": "There is something different with these toner pads! Beyond deep clean and more like resurfacing, even for my 50 year skin. I’ve seen an improvement in my pores especially.  Expensive but worth it.",
        "name": "Liz L.",
        "created_at": "2026-10-26T18:20:35+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1394686532,
        "rating": 5,
        "title": "",
        "body": "Product seems wonderful. I’ve used 2x. Looking forward to see results as time goes on.",
        "name": "Customer",
        "created_at": "2026-10-25T17:21:55+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1394193943,
        "rating": 5,
        "title": "",
        "body": "Excellent",
        "name": "Customer",
        "created_at": "2026-10-24T19:50:42+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1394171712,
        "rating": 5,
        "title": "",
        "body": "Skin looks more youthful. At 67 that’s saying something 😊",
        "name": "Shirley B.",
        "created_at": "2026-10-24T18:42:31+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1393176669,
        "rating": 5,
        "title": "",
        "body": "The product really works. I’m hearing good results from people. I got idea yesterday to go see a radar movie and I’m 37 years old. I’m really surprised. So thank you very much.",
        "name": "Ron H.",
        "created_at": "2026-10-23T17:16:01+00:00",
        "verified": true,
        "pictures": []
      }
    ]
  },
  "test-complete-care-bundle": {
    "productId": 7935965265999,
    "productTitle": "Anti-Aging Glow-Up Bundle",
    "reviews": [
      {
        "id": 1401618973,
        "rating": 5,
        "title": "",
        "body": "Been using for about 6 months… amazing product",
        "name": "Lourdes Teano",
        "created_at": "2026-10-31T02:17:08+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1396073810,
        "rating": 5,
        "title": "",
        "body": "Smooth",
        "name": "Customer",
        "created_at": "2026-10-26T20:51:19+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1386787791,
        "rating": 5,
        "title": "",
        "body": "I like the product it makes me feel good on my skin. You only have one problem the shipping company leave the package outside of the door. They do not put it in front of the door. Package could get stolen. Why are you using this company if they’re not making sure that the package is put on the correct place",
        "name": "HILDA ACEVEDO",
        "created_at": "2026-10-19T11:28:05+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1384855955,
        "rating": 5,
        "title": "",
        "body": "I love the texture my face has now . My wrinkles don't seem so wrinkly!",
        "name": "Jenny R.",
        "created_at": "2026-10-17T19:03:56+00:00",
        "verified": true,
        "pictures": [
          {
            "url": "https://review-images.judgeme.com/jiyu/1792263836__1000009242__original.jpg?quality=80&width=160"
          }
        ]
      },
      {
        "id": 1384837903,
        "rating": 5,
        "title": "",
        "body": "I just started using it. I like it. I was very skeptical to be honest, but one of their sales people reached out on my text messages and kind of talk to me into it so anyway it kind of reminds me of Seabreeze, which I’m sure most people cannot remember, but it smells like that sort of which I like because it reminds me of my childhood but anyway, I like the toner pads and the lotion or cream or whatever is nice and has not bothered my skin. I have sensitive skin so thus far I like it we’ll see how it works after a month or two.!",
        "name": "Customer",
        "created_at": "2026-10-17T18:15:53+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1383108749,
        "rating": 5,
        "title": "",
        "body": "Great product!",
        "name": "John Schnepper",
        "created_at": "2026-10-16T12:05:48+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1382337440,
        "rating": 5,
        "title": "",
        "body": "My husband and I have been using the Anti-Aging Glow-Up bundle for over a month and we are very pleased with the results. We have both noticed an improvement with sun damage and uneven skin. We will be reordering the bundle very soon.",
        "name": "Monica J.",
        "created_at": "2026-10-15T21:57:51+00:00",
        "verified": true,
        "pictures": []
      },
      {
        "id": 1377728901,
        "rating": 5,
        "title": "",
        "body": "My skin feels soft and hydrated. Even toned. So far so good!",
        "name": "Christine B.S.",
        "created_at": "2026-10-14T02:48:33+00:00",
        "verified": true,
        "pictures": []
      }
    ]
  }
};
window.jrReviewsGeneratedAt = "2026-10-31T15:43:39.120Z";
